import { Injectable } from '@angular/core';

import { AuthService } from '../../service/services/auth/auth.service';
import { NavigationService } from '../../service/services/misc/navigation/navigation.service';
import { CoreModule } from '../core.module';

@Injectable({ providedIn: CoreModule })
export class AuthGuard  {
    constructor(private authService: AuthService, private navigationService: NavigationService) {}
    canActivate(): boolean {
        const isAuthenticated = this.authService.isAuthenticated();
        if (!isAuthenticated) {
            this.navigationService.navigateToLoginPage({
                queryParams: { redirectUrl: window.location.pathname + decodeURIComponent(window.location.hash) },
            });
            return false;
        }
        return true;
    }
}
